import { createAction } from "@reduxjs/toolkit";
import { ItemKinds } from "legacy/pages/Editor/PropertyPane/ItemKindConstants";
import { showItemPropertyPane } from "../../../../legacy/actions/propertyPaneActions";
import type { ApplicationScope } from "@superblocksteam/shared";
import type { AppStateVar } from "store/slices/application/stateVars/StateConstants";

export const duplicateStateVar = createAction<{
  fromScope: ApplicationScope;
  toScope: ApplicationScope;
  stateVarId: string;
}>("DUPLICATE_STATE_VAR");

export const deleteStateVar = createAction(
  "DELETE_STATE_VAR",
  (scope: ApplicationScope, id: AppStateVar["id"]) => ({
    payload: { scope, id },
  }),
);

export const editStateVarPropertyPane = (
  stateVarId: string,
  scope: ApplicationScope,
) => showItemPropertyPane({ kind: ItemKinds.STATE_VAR, id: stateVarId, scope });
